(function () {
  var TOGGLE = '.product__media-toggle';

  function items() {
    var el = document.querySelector('[data-pswp-items]');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && parsed.length ? parsed : null;
    } catch (err) {
      return null;
    }
  }

  function indexOfMedia(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return 0;
  }

  function open(index, list) {
    var root = document.querySelector('.pswp');
    if (!root || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return false;

    if (root.parentNode !== document.body) document.body.appendChild(root);

    var gallery = new PhotoSwipe(root, PhotoSwipeUI_Default, list, {
      index: index,
      bgOpacity: 1,
      history: false,
      showHideOpacity: true,
      closeOnScroll: false,
      closeOnVerticalDrag: true,
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      preloaderEl: false,
      closeEl: true,
      arrowEl: true,
      tapToClose: false,
      tapToToggleControls: false,
      getThumbBoundsFn: function (i) {
        var thumb = document.querySelector('[data-media-id$="' + list[i].id + '"] img');
        if (!thumb) return null;
        var rect = thumb.getBoundingClientRect();
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    });
    gallery.init();
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(TOGGLE) : null;
    if (!btn) return;
    var list = items();
    if (!list) return;
    if (open(indexOfMedia(list, btn.getAttribute('data-media-id')), list)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);
})();
